import styled from "styled-components";

export const FestivalMainWrapper = styled.div`
  width: 100%;
`;

export const FestivalMainContent = styled.div`
  margin-top: 12px;
  display: flex;
  flex-direction: column;
  gap: 24px;
  margin-top: 24px;

  .title {
    font-weight: 700;
    font-size: 20px;
    margin-bottom: 12px;
  }
`;
